/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { dataAsBool, findAll, toggle } from '@/js/utils/dom'

function updateVisibility(checkbox) {
    const targetSelectors = checkbox.dataset.checkboxToggle.split(',').map((s) => s.trim())
    const invert = dataAsBool(checkbox, 'checkboxToggleInvert')
    const shouldShow = invert ? !checkbox.checked : checkbox.checked

    targetSelectors.forEach((selector) => {
        findAll(selector).forEach((target) => {
            toggle(target, shouldShow)
        })
    })
}

function onChange(e) {
    updateVisibility(e.currentTarget)
}

/**
 * Toggle the visibility of elements based on the checked state of a checkbox.
 * Targets are looked up document-wide (they usually live outside the
 * checkbox's subtree). Syncs once on connect, then follows `change` events.
 *
 * @type {Listener}
 */
export default {
    selector: '[data-checkbox-toggle]',
    connect(element) {
        updateVisibility(element)
        element.addEventListener('change', onChange)

        return () => element.removeEventListener('change', onChange)
    },
}
